import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-download-db-spreadsheet',
  templateUrl: './download-db-spreadsheet.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, FormsModule, MatButtonModule],
})
export class DownloadDBSpreadsheetComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  @Input() lifeProductTables;
  downloadLifeProducts = { table: null, status: null, statusClass: null };

  exportLifeProducts() {
    this.toggleLoading.emit();
    this.downloadLifeProducts.status = null;
    this.downloadLifeProducts.statusClass = null;
    this.admnSrvc
      .exportLifeProducts(this.downloadLifeProducts.table)
      .subscribe({
        next: res => {
          this.toggleLoading.emit();
          let fileData;
          const filename = `${this.downloadLifeProducts.table.app}-${this.downloadLifeProducts.table.value}.csv`;
          const reader = new FileReader();
          reader.readAsDataURL(res);

          reader.onloadend = () => {
            fileData = reader.result;
            saveAs(fileData, filename);
          };
        },
        error: catchError(err => {
          this.toggleLoading.emit();
          this.downloadLifeProducts.status = err;
          this.downloadLifeProducts.statusClass = 'failure';
          return throwError(() => err.error || 'Server error');
        }),
      });
  }
}
